import {BrowserModule} from '@angular/platform-browser';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {HttpModule} from '@angular/http';
import {RouteReuseStrategy} from '@angular/router';
import {ScrollToModule} from '@nicky-lenaers/ngx-scroll-to';


import {AppComponent} from './app.component';
import {PageSingleComponent} from './pages/page-single/page-single.component';
import {PageHomeComponent} from './pages/page-home/page-home.component';
import {Wpng2RoutingModule} from './app-routing.module';
import {HtmlSanitizerPipe} from './pipes/html-sanitizer.pipe';
import {UrlSanitizerPipe} from './pipes/url-sanitizer.pipe';
import {UIService} from './services/ui.service';
import {MenuService} from './services/menu.service';
import {MenuComponent} from './menu/menu.component';
import {SpanGroupsPipe} from './pipes/span-groups.pipe';
import {ResourceUrlSanitizerPipe} from './pipes/resource-url-sanitizer.pipe';
import {ImageWithPlaceholderComponent} from './image-with-placeholder/image-with-placeholder.component';
import {CustomReuseStrategy} from './app-routing.module';
import {AnimationGuard} from './app-routing.module';

import { Angulartics2Module } from 'angulartics2';
import { Angulartics2GoogleAnalytics } from 'angulartics2/ga';

@NgModule({
  declarations: [
    MenuComponent,
    AppComponent,
    PageSingleComponent,
    PageHomeComponent,
    HtmlSanitizerPipe,
    UrlSanitizerPipe,
    SpanGroupsPipe,
    ResourceUrlSanitizerPipe,
    ImageWithPlaceholderComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpModule,
    Wpng2RoutingModule,
    ScrollToModule.forRoot(),
    Angulartics2Module.forRoot([Angulartics2GoogleAnalytics])
  ],
  providers: [AnimationGuard, UIService, MenuService, {provide: RouteReuseStrategy, useClass: CustomReuseStrategy}],
  bootstrap: [AppComponent]
})

export class AppModule {
}



// WEBPACK FOOTER //
// ./src/app/app.module.ts